export default "__VITE_ASSET__DEhmPJRw__"